import { Component, Input } from '@angular/core';
import { NewReportResponse, ReportingsCollection } from '../../interfaces/new-reporting-filter';

@Component({
  selector: 'avs-reporting-visualizer',
  standalone: false,
  templateUrl: './reporting-visualizer.component.html',
  styleUrl: './reporting-visualizer.component.css'
})
export class ReportingVisualizerComponent {

  @Input() report: ReportingsCollection | null = null;

}
